import React, { ReactElement, useEffect, useState } from 'react';
import { Headline, Text } from '../../../../../components';

// Handles the actual display of search results.
export default function SearchResults({ searchQuery }: any): ReactElement {
  // By default we only want to show the first 11 search results.
  // const [resultsOffset, setResultsOffset] = useState<number>(0);
  // const [resultsEnd, setResultsEnd] = useState<number>(11);
  const [results, setResults] = useState<any>([]);
  const [isSearching, setIsSearching] = useState<boolean>(true);

  useEffect(() => {
    async function fetchSearchResults() {
      const response = await fetch(
        `/.netlify/functions/search-knowledge-center?query=${searchQuery}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const body = await response.json();
      setResults(body.data['library-posts']);
      setIsSearching(false);
    }

    fetchSearchResults();
  }, [searchQuery]);

  return (
    <>
      {!isSearching && results && (
        <div className="mb-8 flex items-center justify-between border-b border-solid border-b-neutral-gray-100 pb-8">
          <Headline level="2">Search results for “{searchQuery}”</Headline>

          <Text level="mono" className="ml-4 whitespace-nowrap">
            {results.length} {results.length === 1 ? 'RESULT' : 'RESULTS'}
          </Text>
        </div>
      )}

      {isSearching ? (
        <div className="mb-8 border-b border-solid border-b-neutral-gray-100 pb-8">
          <Headline level="2" className="animate-fade-in-out">
            Searching for “{searchQuery}”...
          </Headline>
        </div>
      ) : results?.length > 0 ? (
        <div>
          <ul>
            {results.map((post) => (
              <li key={post.url} className="mb-16">
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group no-underline">
                  <Text
                    level="mono"
                    className="line-clamp-2 uppercase group-hover:underline">
                    <span>{post.title}</span>
                  </Text>
                  {/*
                  // NEED TO FIND A WAY TO BRING THE CATEGORY INTO THE SEARCH RESULTS
                  <Label
                    level="mono"
                    className="line-clamp-1 uppercase">
                    <span>{post.category}</span>

                    <span>{` // `}</span>

                    <span>{post.title}</span>
                  </Label> */}

                  <Text className="mt-2 line-clamp-2 group-hover:underline">
                    {post.description}
                  </Text>
                </a>
              </li>
            ))}
          </ul>

          {/*
          // Will disable for now since we are only returning a handful of results
          // to ensure we aren't taxing our strapi instance
          <div className="flex justify-center">
            <Button
              isDisabled={resultsOffset === 0}
              buttonType="secondary"
              size="small"
              onClick={() => {
                setResultsOffset(resultsOffset + 12);
                setResultsEnd(resultsEnd + 12);
                if (typeof window !== undefined) {
                  window.scrollTo(0, 0);
                }
              }}>
              Prev
            </Button>

            <Button
              isDisabled={
                results.length < 10 || resultsOffset + 10 > results.length
              }
              className="ml-4"
              buttonType="secondary"
              size="small"
              onClick={() => {
                setResultsOffset(resultsOffset - 12);
                setResultsEnd(resultsEnd - 12);
                if (typeof window !== undefined) {
                  window.scrollTo(0, 0);
                }
              }}>
              Next
            </Button>
          </div> */}
        </div>
      ) : (
        <div className="mt-16 flex items-center justify-between [&_img]:w-auto max-[1048px]:[&_img]:hidden max-[840px]:[&_img]:block max-[540px]:[&_img]:hidden">
          <div className="max-w-100 max-[1048px]:w-full max-[840px]:max-w-110 max-[540px]:max-w-full">
            <Text level="mono" color="purple" className="mb-4">
              Whoops
            </Text>

            <Headline level="2">We couldn’t find any matches.</Headline>

            <Text className="mt-6 mb-8">
              Try another keyword or phrase and we’ll find what you’re looking
              for.
            </Text>
          </div>

          <img
            src="https://res.cloudinary.com/stark-lab/image/upload/v1761248491/marketing/library/empty-state-search_ptgvhm.png"
            height={362}
            width={300}
            alt="A magnifying glass with illustrated squiggles"
          />
        </div>
      )}
    </>
  );
}
